import { format, differenceInYears, isValid } from 'date-fns';

/**
 * format: 31 Jan 2024
 */
export const formatDate = (date: Date): string => {
  return format(date, 'dd MMM yyyy');
};

/**
 * format: 31 Jan 2024 12:34:56
 */
export const formatDateTime = (date: Date): string => {
  return format(date, 'dd MMM yyyy hh:mm:ss');
};

/**
 * format: 2024-01-31
 */
export const formatRequestDate = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

/**
 * format: 31/01/2024 — used for user-facing date inputs that are read-only.
 * Submit-side payloads must continue to use {@link formatRequestDate}.
 */
export const formatDisplayDate = (date: Date): string => {
  return format(date, 'dd/MM/yyyy');
};

export const getIsoDate = (date?: Date) => {
  if (date && isValid(date))
    return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
  else return format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
};

export const getAgeInYearFromDate = (date: Date): number => {
  return differenceInYears(new Date(), date);
};

export const safeDate = (input: Date | string | number | undefined): Date => {
  const date = new Date(input ?? new Date());
  if (isNaN(date.getTime())) {
    console.error('Invalid date created from input:', input);
    return new Date();
  }
  return date;
};
